import React from 'react';

const LineMailOpenSvg = ({ size = 18 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M2.25 7.5L9 3L15.75 7.5V13.5C15.75 14.3284 15.0784 15 14.25 15H3.75C2.92157 15 2.25 14.3284 2.25 13.5V7.5Z" />
    <path d="M2.25 7.5L9 12L15.75 7.5" />
  </svg>
);

export default LineMailOpenSvg;
